import { render, staticRenderFns } from "./LazyloadImage.vue?vue&type=template&id=5a668858&scoped=true&"
import script from "./LazyloadImage.vue?vue&type=script&lang=ts&"
export * from "./LazyloadImage.vue?vue&type=script&lang=ts&"
import style0 from "./LazyloadImage.vue?vue&type=style&index=0&id=5a668858&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a668858",
  null
  
)

export default component.exports